<nav mat-tab-nav-bar [tabPanel]="tabPanel">
  <a mat-tab-link routerLink="list" routerLinkActive #rla1="routerLinkActive" [active]="rla1.isActive">Customers</a>
  <a mat-tab-link routerLink="clients" routerLinkActive #rla2="routerLinkActive" [active]="rla2.isActive">Clients</a>
</nav>
<mat-tab-nav-panel #tabPanel>
  <router-outlet></router-outlet>
</mat-tab-nav-panel>
